// Deribit's transaction `timestamp` comes back without a timezone suffix
// (e.g. "2026-07-06 00:01:59.879") but the value is UTC. OKX's rows already
// carry an explicit offset (e.g. "...+00:00"). Native `new Date(...)`
// parsing of the space-separated, no-offset Deribit format is treated as
// LOCAL time by JS engines, silently shifting it by the local UTC offset
// (an hour out under BST) — so every timestamp read must go through this,
// not a bare `new Date(tx.timestamp)`.
export const parseUtcTimestamp = (raw: string | null | undefined): Date | null => {
  if (!raw) return null;

  const hasTimezone = /[Zz]|[+-]\d{2}:?\d{2}$/.test(raw);
  const isoish = raw.includes('T') ? raw : raw.replace(' ', 'T');
  const withZone = hasTimezone ? isoish : `${isoish}Z`;

  const date = new Date(withZone);
  return Number.isNaN(date.getTime()) ? null : date;
};
